module.exports = __webpack_public_path__ + "frontend/images/white/carousel/static/europe@2.png?f70789e350cd9c8da02427590d9350bb";